var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { CurrencyContext } from '../../context/currency';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import { appEnv } from '../../env';
import { sleep } from '../../utils/async';
export var DEFAULT_CTA_TOKEN_VALUE = 100;
export var CTA_TOKEN_SKU = 'CTA_TOKEN';
export var STRIPE_CTA_TOKEN_FEE = 1.05;
export var MIN_SUPPLY_VALUE = process.env.REACT_APP_ENV === 'testing' ? 10 : 100000;
export function useBuy(timestamp) {
    var t = useI18n().t;
    var _a = useContext(UserContext), user = _a.user, reconnectUser = _a.reconnectUser;
    var _b = useContext(CurrencyContext), imxClient = _b.imxClient, parseCurrencyQuantity = _b.parseCurrencyQuantity;
    var _c = useContext(LoadingContext), setImxLoading = _c.setImxLoading, setServerLoading = _c.setServerLoading;
    var _d = useState(DEFAULT_CTA_TOKEN_VALUE), ctaTokenValue = _d[0], setCtaTokenValue = _d[1];
    var _e = useState(0), usdValue = _e[0], setUsdValue = _e[1];
    var _f = useState(false), showConfirmDialog = _f[0], setShowConfirmDialog = _f[1];
    var _g = useState(false), showSuccessDialog = _g[0], setShowSuccesDialog = _g[1];
    var _h = useState(undefined), errorMessage = _h[0], setErrorMessage = _h[1];
    var _j = useState(false), acceptTerms = _j[0], setAcceptTerms = _j[1];
    var _k = useState(false), showSupplyError = _k[0], setShowSupplyError = _k[1];
    useEffect(function () {
        function getUsdValue() {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, gqlSdk.PaymentGetCtaTokenUsdPrice({
                                input: { ctaTokenUsdValueTimestamp: timestamp, quantity: ctaTokenValue },
                            })];
                        case 1:
                            result = _a.sent();
                            setUsdValue(result.paymentGetCtaTokenUsdPrice.usdPrice);
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (user && ctaTokenValue && timestamp.length > 0) {
            getUsdValue();
        }
    }, [ctaTokenValue, timestamp, user]);
    useEffect(function () {
        function getSupply() {
            return __awaiter(this, void 0, void 0, function () {
                var ownerBalance, ctaTokenOwnerBalance, ctaTokenOwnerValue;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            setImxLoading(true);
                            return [4 /*yield*/, imxClient.listBalances({ owner: appEnv.ctaTokenHolderShopWalletAddress })];
                        case 1:
                            ownerBalance = _b.sent();
                            ctaTokenOwnerBalance = ownerBalance.result.find(function (balance) { return balance.symbol === CurrencyTokenSymbol.CTA; });
                            ctaTokenOwnerValue = ctaTokenOwnerBalance
                                ? ((_a = parseCurrencyQuantity(ctaTokenOwnerBalance.balance, appEnv.ctaTokenAddress).base) === null || _a === void 0 ? void 0 : _a.value) || 0
                                : 0;
                            setShowSupplyError(ctaTokenOwnerValue < MIN_SUPPLY_VALUE);
                            setImxLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getSupply();
    }, [imxClient]);
    function buyWithStripe() {
        return __awaiter(this, void 0, void 0, function () {
            var response, order, passed, respone, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (ctaTokenValue <= 0)
                            return [2 /*return*/];
                        setServerLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 10, , 11]);
                        return [4 /*yield*/, gqlSdk.PaymentCreateStripeOrder({
                                input: { itemSku: CTA_TOKEN_SKU, quantity: ctaTokenValue, ctaTokenUsdValueTimestamp: timestamp },
                            })];
                    case 2:
                        response = _b.sent();
                        order = response.paymentCreateStripeOrder;
                        window.open(order.buyUrl, '_blank');
                        passed = false;
                        _b.label = 3;
                    case 3: return [4 /*yield*/, gqlSdk.PaymentOrderStatus({
                            input: { orderUuid: order.orderUuid },
                        })];
                    case 4:
                        respone = _b.sent();
                        passed = respone.paymentOrderStatus.passed;
                        setShowSuccesDialog(passed);
                        setShowConfirmDialog(!passed);
                        if (!!passed) return [3 /*break*/, 6];
                        return [4 /*yield*/, sleep(2000)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        if (passed === false) return [3 /*break*/, 3];
                        _b.label = 7;
                    case 7:
                        setErrorMessage(undefined);
                        return [4 /*yield*/, sleep(1000)];
                    case 8:
                        _b.sent();
                        return [4 /*yield*/, reconnectUser()];
                    case 9:
                        _b.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        _a = _b.sent();
                        setErrorMessage(t('error.generic'));
                        return [3 /*break*/, 11];
                    case 11:
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function buyWithMixPay() {
        return __awaiter(this, void 0, void 0, function () {
            var response, order, passed, respone, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (ctaTokenValue <= 0)
                            return [2 /*return*/];
                        setServerLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 10, , 11]);
                        return [4 /*yield*/, gqlSdk.PaymentCreateMixPayOrder({
                                input: { itemSku: CTA_TOKEN_SKU, quantity: ctaTokenValue, ctaTokenUsdValueTimestamp: timestamp },
                            })];
                    case 2:
                        response = _b.sent();
                        order = response.paymentCreateMixPayOrder;
                        window.open(order.buyUrl, '_blank');
                        passed = false;
                        _b.label = 3;
                    case 3: return [4 /*yield*/, gqlSdk.PaymentOrderStatus({
                            input: { orderUuid: order.orderUuid },
                        })];
                    case 4:
                        respone = _b.sent();
                        passed = respone.paymentOrderStatus.passed;
                        setShowSuccesDialog(passed);
                        setShowConfirmDialog(!passed);
                        if (!!passed) return [3 /*break*/, 6];
                        return [4 /*yield*/, sleep(2000)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        if (passed === false) return [3 /*break*/, 3];
                        _b.label = 7;
                    case 7:
                        setErrorMessage(undefined);
                        return [4 /*yield*/, sleep(1000)];
                    case 8:
                        _b.sent();
                        return [4 /*yield*/, reconnectUser()];
                    case 9:
                        _b.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        _a = _b.sent();
                        setErrorMessage(t('error.generic'));
                        return [3 /*break*/, 11];
                    case 11:
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function onCloseConfirmDialog() {
        setAcceptTerms(false);
        setShowConfirmDialog(false);
    }
    function onCloseSuccessDialog() {
        setShowSuccesDialog(false);
    }
    return {
        ctaTokenValue: ctaTokenValue,
        setCtaTokenValue: setCtaTokenValue,
        usdValue: usdValue,
        buyWithStripe: buyWithStripe,
        buyWithMixPay: buyWithMixPay,
        showConfirmDialog: showConfirmDialog,
        setShowConfirmDialog: setShowConfirmDialog,
        showSuccessDialog: showSuccessDialog,
        setShowSuccesDialog: setShowSuccesDialog,
        onCloseConfirmDialog: onCloseConfirmDialog,
        onCloseSuccessDialog: onCloseSuccessDialog,
        errorMessage: errorMessage,
        acceptTerms: acceptTerms,
        setAcceptTerms: setAcceptTerms,
        showSupplyError: showSupplyError,
    };
}
